import React from 'react';
import { Badge } from './ui/badge';
import { getStatusColor, getStatusLabel } from '../utils/helpers';

const StatusChip = ({ status, showDot = true, className = '' }) => {
  const color = getStatusColor(status);
  const label = getStatusLabel(status);

  const colorClasses = {
    emerald: 'bg-emerald-50 text-emerald-800 border-emerald-200',
    amber: 'bg-amber-50 text-amber-900 border-amber-200',
    rose: 'bg-rose-50 text-rose-900 border-rose-200',
    slate: 'bg-slate-50 text-slate-900 border-slate-200',
    cyan: 'bg-cyan-50 text-cyan-900 border-cyan-200',
  };

  const dotClasses = {
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    rose: 'bg-rose-500',
    slate: 'bg-slate-500',
    cyan: 'bg-cyan-500',
  };

  return (
    <Badge
      data-testid="status-chip"
      variant="outline"
      className={`${colorClasses[color]} ${className} flex items-center gap-1.5`}
    >
      {showDot && <span className={`w-1.5 h-1.5 rounded-full ${dotClasses[color]}`} />}
      {label}
    </Badge>
  );
};

export default StatusChip;
